// extracted by mini-css-extract-plugin
export default {"Container":"VideoItem_Container__Aybzb","Body":"VideoItem_Body__vbg9N","Info":"VideoItem_Info__KeHCF"};